/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlsListMappingResponse {
    getFixupPrototypeFunction() { return ControlsListMappingResponse.fixupPrototype; }

    static newInstance(model: Partial<ControlsListMappingResponse>): ControlsListMappingResponse {
        let obj = Object.assign(new ControlsListMappingResponse(), model);
        ControlsListMappingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlsListMappingResponse>): ControlsListMappingResponse {
        if (!model) return null;
        return ControlsListMappingResponse.newInstance(<ControlsListMappingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlsListMappingResponse) {
        if (!obj) return;

        models.ControlsListMappingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlsListMappingResponse): boolean {
        Object.setPrototypeOf(obj, ControlsListMappingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.control_records) {
            models.ControlMappingsListData.fixupPrototype(this.control_records);
        }
    }

    /**
     * Number of controls in the standard
     */
    total_count: number;

    /**
     * list of application details.
     */
    control_records: models.ControlMappingsListData;

}
